import React, { useEffect } from "react";
import { setPageSEO } from '../utils/seo.js';
import "./Contact.css";

function Contact() {
  useEffect(() => setPageSEO({
    title: "Contact Clientalio - We're Here to Help",
    description: 'Get in touch with the Clientalio team for support, partnerships, product inquiries, or feature requests.',
    canonical: 'https://clientalio.com/contact',
    ogTitle: "Contact Clientalio - We're Here to Help",
    ogDescription: 'Get in touch with the Clientalio team for support, partnerships, product inquiries, or feature requests.',
    twitterTitle: "Contact Clientalio - We're Here to Help",
    twitterDescription: 'Get in touch with the Clientalio team for support, partnerships, product inquiries, or feature requests.'
  }), []);

  return (
    <main className="contact-page">
      <section className="contact-panel">
        <div className="contact-header">
          <p className="contact-eyebrow">Contact Us</p>

          <h1>Get in Touch with Clientalio</h1>

          <p>
            Have a question about collecting, managing, or sharing
            testimonials? Reach out to our team—we're happy to help.
          </p>
        </div>

        <div className="contact-cards" aria-label="Contact details">
          {/* Contact Form */}
          <a
            className="contact-card"
            href="https://forms.gle/SeKMVJBkomi5dz8R9"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="contact-icon" aria-hidden="true">
              📋
            </span>

            <span>
              <strong>Contact Form</strong>
              <span>Submit your query online</span>
            </span>
          </a>

          {/* Email */}
          <a
            className="contact-card"
            href="mailto:support@clientalio.com"
          >
            <span className="contact-icon" aria-hidden="true">
              <svg
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="M22 6L12 13 2 6" />
              </svg>
            </span>

            <span>
              <strong>Email</strong>
              <span>support@clientalio.com</span>
            </span>
          </a>
        </div>
      </section>
    </main>
  );
}

export default Contact;